import React from 'react';
import useScreenOrientation from './helpers/useScreenOrientation';

export default function UserForm({ isVisible, setView, setUserID }: any) {

  const isLandscape = useScreenOrientation();

  const [name, setName] = React.useState("");
  const [nameError, setNameError] = React.useState(false);

  const [cc, setCC] = React.useState("");
  const [ccError, setCCError] = React.useState(false);

  const [refering, setRefering] = React.useState("");
  const [referingError, setReferingError] = React.useState(false);

  const [acceptTerms1, setAcceptTerms1] = React.useState(false);
  const [acceptTermsError1, setAcceptTermsError1] = React.useState(false);
  const [acceptTerms2, setAcceptTerms2] = React.useState(false);
  const [acceptTermsError2, setAcceptTermsError2] = React.useState(false);
  const [acceptTerms3, setAcceptTerms3] = React.useState(false);
  const [acceptTermsError3, setAcceptTermsError3] = React.useState(false);
  const [acceptTerms4, setAcceptTerms4] = React.useState(false);
  const [acceptTermsError4, setAcceptTermsError4] = React.useState(false);

  const [sendingForm, setSendingForm] = React.useState(false);

  const checkName = (name: string) => {
    const filteredName = name.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, '');
    setName(filteredName)
    setNameError(filteredName === '')
  };

  const checkCC = (cc: string) => {
    setCC(cc)
    setCCError(cc.length < 4)
  };

  const checkReferring = (refering: string) => {
    setRefering(refering)
    setReferingError(refering === '')
  };

  const checkTerms1 = (accepted: boolean) => {
    setAcceptTerms1(accepted);
    setAcceptTermsError1(accepted === false);

    checkName(name);
    checkCC(cc);
    checkReferring(refering);
  };

  const checkTerms2 = (accepted: boolean) => {
    setAcceptTerms2(accepted);
    setAcceptTermsError2(accepted === false);

    checkName(name);
    checkCC(cc);
    checkReferring(refering);
  };

  const checkTerms3 = (accepted: boolean) => {
    setAcceptTerms3(accepted);
    setAcceptTermsError3(accepted === false);

    checkName(name);
    checkCC(cc);
    checkReferring(refering);
  };
  const checkTerms4 = (accepted: boolean) => {
    setAcceptTerms4(accepted);
    setAcceptTermsError4(accepted === false);

    checkName(name);
    checkCC(cc);
    checkReferring(refering);
  };

  const verifyAllInputs = () => {
    checkName(name);
    checkCC(cc);
    checkReferring(refering);
    checkTerms1(acceptTerms1);
    checkTerms2(acceptTerms2);
    checkTerms3(acceptTerms3);
    checkTerms4(acceptTerms4);
    if(nameError === false && 
      ccError === false &&
      referingError === false &&
      acceptTermsError1 === false &&
      acceptTerms1 === true &&
      acceptTermsError2 === false &&
      acceptTerms2 === true &&
      acceptTermsError3 === false &&
      acceptTerms3 === true &&
      acceptTermsError4 === false &&
      acceptTerms4 === true
    ){
        SendUserDataForm();
    }
  };

  const SendUserDataForm = () => {
    setSendingForm(true)
    fetch('https://x0cv9pf8rj.execute-api.us-east-1.amazonaws.com/api/registre-tetris', { //https://x0cv9pf8rj.execute-api.us-east-1.amazonaws.com/api/registre_runner
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(
        {
          "cc": cc,
          "name": name,
          "referring": refering,
          "terms1": acceptTerms1 ? 1 : 0,
          "terms2": acceptTerms2 ? 1 : 0,
          "terms3": acceptTerms3 ? 1 : 0,
          "terms4": acceptTerms4 ? 1 : 0,
        }
      )
    }
    ).then(response => {
      setSendingForm(false)
      response.json().then(jSonResponse => {
        if (jSonResponse.statusCode === 200) {
          console.log("User Data Form Sent!")
          setUserID(jSonResponse.id)
          setView("Instructions")
        }
        console.log(jSonResponse)
      })
    }
    )
      .then(responseData => {
        console.log(responseData)
      })
      .catch(error => {
        console.error("Error sending User Data Form")
        console.error(error)
        setSendingForm(false)
      });
  }

  return (
    <div className={`full-userform-container ${isVisible === true ? 'active' : 'hidden'}`}>

      <div className={`userform-container ${isLandscape ? '' : 'portrait'}`}>

        <div className={`userform-container-title ${isLandscape ? '' : 'portrait'}`}>Regístrate</div>

        <div className={`userform-container-grid ${isLandscape ? '' : 'portrait'}`}>

          <div className={`userform-input-container ${isLandscape ? '' : 'portrait'}`}>
            <div className={`userform-input-title ${nameError ? 'error' : ''} ${isLandscape ? '' : 'portrait'}`}>Nombre completo</div>
            <input value={name} className={`userform-input ${nameError ? 'error' : ''}`} type='text' onChange={(e: any) => { checkName(e.target.value) }}></input>
            <div className='userform-warning-text'>{nameError ? "Este campo es obligatorio." : ""}</div>
          </div>

          <div className={`userform-input-container ${isLandscape ? '' : 'portrait'}`}>
            <div className={`userform-input-title ${ccError ? 'error' : ''} ${isLandscape ? '' : 'portrait'}`}>Últimos 4 dígitos de tu cédula</div>
            <input className={`userform-input ${ccError ? 'error' : ''}`} type='number' onChange={(e: any) => { checkCC(e.target.value) }}></input>
            <div className='userform-warning-text'>{ccError ? "Este campo es obligatorio." : ""}</div>
          </div>

          <div className={`userform-input-container ${isLandscape ? '' : 'portrait'}`}>
            <div className={`userform-input-title ${referingError ? 'error' : ''} ${isLandscape ? '' : 'portrait'}`}>Código del Referente</div>
            <input className={`userform-input ${referingError ? 'error' : ''}`} type='number' onChange={(e: any) => { checkReferring(e.target.value) }}></input>
            <div className='userform-warning-text'>{referingError ? "Este campo es obligatorio." : ""}</div>
          </div>

          {/* <div className={`userform-input-container ${isLandscape ? '' : 'portrait'}`}>
            <div className={`userform-checkbox-text ${isLandscape ? '' : 'portrait'}`}>*Si no conoce su número de pagaré, debe solicitarlo al almacén en donde realizó la compra.</div>
          </div> */}

          <div className={`userform-input-checkbox ${isLandscape ? '' : 'portrait'} ${acceptTermsError1 ? 'error' : ''}`}>
            <input id='acceptTerms1' type='checkbox' onChange={(e: any) => { checkTerms1(e.target.checked) }}></input>
            <div className={`userform-checkbox-text ${isLandscape ? '' : 'portrait'}`}>
              Acepto que es mi responsabilidad ingresar correctamente todos los datos, incluyendo el nombre completo como aparece en mi cédula , el código del referente y los últimos 4 dígitos del documento de identidad.
            </div>
          </div>
          <div className={`userform-input-checkbox ${isLandscape ? '' : 'portrait'} ${acceptTermsError2 ? 'error' : ''}`}>
            <input id='acceptTerms2' type='checkbox' onChange={(e: any) => { checkTerms2(e.target.checked) }}></input>
            <div className={`userform-checkbox-text ${isLandscape ? '' : 'portrait'}`}>
              Entiendo que cualquier error, omisión o inconsistencia en esta información puede causar descalificación automática y pérdida del derecho al premio.
            </div>
          </div>

          <div className={`userform-input-checkbox ${isLandscape ? '' : 'portrait'} ${acceptTermsError3 ? 'error' : ''}`}>
            <input id='acceptTerms3' type='checkbox' onChange={(e: any) => { checkTerms3(e.target.checked) }}></input>
            <div className='userform-checkbox-text'>
              Acepto los <a className='userform-checkbox-link' href='https://www.sistecredito.com/terminos-y-condiciones-generales/' target='_blank' rel='noreferrer'>Términos y condiciones de Sistecredito</a>
            </div>
          </div>

          <div className={`userform-input-checkbox ${isLandscape ? '' : 'portrait'} ${acceptTermsError4 ? 'error' : ''}`}>
            <input id='acceptTerms4' type='checkbox' onChange={(e: any) => { checkTerms4(e.target.checked) }}></input>
            <div className={`userform-checkbox-text ${isLandscape ? '' : 'portrait'}`}>
              Autorizo el uso de mis datos y recibir información de la campaña. 
            </div>
          </div>

        </div>

        <div className={`userform-send-button ${isLandscape ? '' : 'portrait'} ${(nameError || ccError || referingError || acceptTermsError1 || acceptTermsError2 || acceptTermsError3 || acceptTermsError4 || sendingForm) ? 'error' : ''}`} onClick={() => { if (!nameError && !ccError && !referingError && !acceptTermsError1 && !acceptTermsError2 && !acceptTermsError3 && !acceptTermsError4 && !sendingForm) verifyAllInputs() }}>
          <div className={`userform-send-button-text ${isLandscape ? '' : 'portrait'}`}>{sendingForm === true ? 'Enviando' : 'Continuar'}</div>
        </div>

      </div>
    </div>
  );
}